import { defineComponent as _defineComponent } from 'vue'
import { ref, onMounted, onUnmounted } from '../../../../../adapter-vue';
import {
  TUIStore,
  StoreName,
  IMessageModel,
} from '@tencentcloud/chat-uikit-engine';
import ConvertContent from './convert-content.vue';
import { IConvertInfo } from '../../../../../interface';

interface IProps {
  message: IMessageModel;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  props: {
    message: { default: () => ({} as IMessageModel) }
  },
  setup(__props: any) {

const props = __props as { message: IMessageModel }



const convertVisible = ref<boolean>(false);
const hasConvertError = ref<boolean>(false);
const convertWrapperRef = ref<HTMLDivElement>();

let isSingleConvert = true;

onMounted(() => {
  TUIStore.watch(StoreName.CHAT, {
    voiceToTextInfo: onMessageConvertUpdated,
  });
});

onUnmounted(() => {
  TUIStore.unwatch(StoreName.CHAT, {
    voiceToTextInfo: onMessageConvertUpdated,
  });
});

function toggleErrorStatus(hasError: boolean) {
  hasConvertError.value = hasError;
}

function onMessageConvertUpdated(info: Map<string, IConvertInfo[]>) {
  if (info === undefined) return;
  isSingleConvert = false;
  const convertInfoList = info.get(props.message.conversationID) || [];
  for (let i = 0; i < convertInfoList.length; ++i) {
    const { messageID, visible } = convertInfoList[i];
    if (messageID === props.message.ID && visible !== undefined) {
      if (convertInfoList.length === 1 && visible) {
        isSingleConvert = true;
      }
      hasConvertError.value = false;
      convertVisible.value = visible;
      break;
    }
  }
}

return { __sfc: true,props, convertVisible, hasConvertError, convertWrapperRef, isSingleConvert, toggleErrorStatus, onMessageConvertUpdated, ConvertContent }
}

})